import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {AirbnbAuth, AirbnbRedirectVerification} from '../../../../models/airbnbAuthModel';
import {PillButton} from '../../../../components/Button';

interface AirbnbRedirectButtonProps {
  method: AirbnbRedirectVerification;
}

interface WithInjectedProps extends AirbnbRedirectButtonProps {
  airbnbAuth: AirbnbAuth;
}

@inject('airbnbAuth')
@observer
export default class AirbnbRedirectButton extends React.Component<AirbnbRedirectButtonProps, {}> {
  public render() {
    return (
      <PillButton onClick={this._markAsClicked} variant="secondary">
        Redirect
      </PillButton>
    );
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private _markAsClicked = () => {
    this._withInjectedProps.airbnbAuth.markRedirectLinkAsClicked(this.props.method);
    window.open(this.props.method.linkRedirect);
  };
}



// WEBPACK FOOTER //
// ./src/containers/AirbnbRedirectVerificationProcedure/private/AirbnbRedirectButton/AirbnbRedirectButton.tsx